// extracted by mini-css-extract-plugin
module.exports = {"arrowHead":"Arrowhead_arrowHead__vl0SZ"};